// Mock data for 강남놀이터 코엑스점

export const images = {
  // SAFE IMAGES ONLY - All problematic images removed per user request
  hero: 'https://customer-assets.emergentagent.com/job_d6d15028-614d-4fe3-aaf1-b4ceb1cf0d24/artifacts/gol5wp0g_file_000000007f44720694530ec904dd8f7d.png',
  firepit: 'https://customer-assets.emergentagent.com/job_d6d15028-614d-4fe3-aaf1-b4ceb1cf0d24/artifacts/gol5wp0g_file_000000007f44720694530ec904dd8f7d.png',
  firepit2: 'https://customer-assets.emergentagent.com/job_d6d15028-614d-4fe3-aaf1-b4ceb1cf0d24/artifacts/gol5wp0g_file_000000007f44720694530ec904dd8f7d.png', // Alias for firepit
  indoor: 'https://customer-assets.emergentagent.com/job_d6d15028-614d-4fe3-aaf1-b4ceb1cf0d24/artifacts/6yy1t27k_file_0000000049bc71fab8caa979091f5fc7.png',
  
  // User uploaded safe images
  rooftopDogFirepit: 'https://customer-assets.emergentagent.com/job_coex-funzone/artifacts/vyqyb667_20251103_161841.jpg',
  rooftopBalcony: 'https://customer-assets.emergentagent.com/job_coex-funzone/artifacts/amd0ijcn_20251103_163916.jpg',
  rooftopNight: 'https://customer-assets.emergentagent.com/job_coex-funzone/artifacts/uhomhvt0_20251211_222704%281%29.jpg',
  
  // NEW BATCH - User uploaded images (faces blurred, not red-marked)
  wideIndoorParty: 'https://customer-assets.emergentagent.com/job_31043bdb-1e4d-4614-86b7-587471ea4c53/artifacts/07k3w6nq_2.png',
  snowyRooftopGroup: 'https://customer-assets.emergentagent.com/job_31043bdb-1e4d-4614-86b7-587471ea4c53/artifacts/cr4btlwx_3.png',
  indoorDining: 'https://customer-assets.emergentagent.com/job_31043bdb-1e4d-4614-86b7-587471ea4c53/artifacts/0tspknyq_4.png',
  rooftopFirepitDog: 'https://customer-assets.emergentagent.com/job_31043bdb-1e4d-4614-86b7-587471ea4c53/artifacts/bqr4bulw_5.png',
  champagneGaming: 'https://customer-assets.emergentagent.com/job_31043bdb-1e4d-4614-86b7-587471ea4c53/artifacts/4sv0p09s_1767532471948.jpg',
  
  // PERMANENTLY REMOVED - DO NOT REUSE (RED FACE MARKINGS):
  // birthday: k1aq2lei_1765071889405.jpg
  // firepit1: ncvd4j5b_1764901319053.jpg
  // bbqRooftop: xious9mx_1764508858815.jpg
  // barLounge: b0wx94ag_1764855631611.jpg
  // gamingLounge: pjhr5p8e_1764489387719.jpg
  // pokerRoom: 4zzajkld_1764489466748.jpg
  // bridalShower: 8qc0zd1m_1764507602483.jpg
  // pokerGame: c1cis24s_1.png - RED PIXELATED FACES
};

export const galleryImages = [
  images.hero,
  images.rooftopNight,
  images.rooftopDogFirepit,
  images.rooftopBalcony,
  images.firepit,
  images.indoor,
  images.champagneGaming,
  // New batch - duplicates removed
  images.wideIndoorParty,
  images.snowyRooftopGroup,
  images.indoorDining,
];

export const externalLinks = {
  naverStore: 'https://smartstore.naver.com/coexnoriteo',
  naverPlace: 'https://naver.me/FoIkUP6Y', 
  naverMapReview: 'https://map.naver.com/p/entry/place/2011036588?placePath=/review', 
  spacecloud: 'https://www.spacecloud.kr/space/74882',
  kakao: 'https://talk.naver.com/ct/w15cfvh?frm=pnmb#nafullscreen', 
  instagram: 'https://www.instagram.com/gangnamnoriteocoex/',
  phone: 'tel:010-5446-8087',
  naverMap: 'https://maps.app.goo.gl/SDBiVuv43cDGCHja8',
  googleMap: 'https://maps.app.goo.gl/SDBiVuv43cDGCHja8'
};

export const blogReviews = [
  {
    id: 1,
    url: 'https://blog.naver.com/rabblt0701/224141985288',
    thumbnail: images.rooftopBalcony,
    titleKr: '강남놀이터 루프탑 파티룸 후기',
    titleEn: 'Gangnam Playground Rooftop Review',
    excerptKr: '강남 한복판에서 이런 루프탑 공간이 있다니! 불멍하면서 친구들과 힐링했어요.',
    excerptEn: 'Amazing rooftop space right in Gangnam! Had a great healing time with friends by the fire.'
  },
  {
    id: 2,
    url: 'https://blog.naver.com/woolru/224112143268',
    thumbnail: images.rooftopNight,
    titleKr: '아이 생일파티 장소로 완벽!',
    titleEn: 'Perfect for Kids Birthday Party!',
    excerptKr: '아이들 생일파티로 단독 대관했는데 정말 만족스러웠어요. 다음에 또 올게요!',
    excerptEn: 'Rented the whole place for kids birthday - absolutely satisfied! Will come back!'
  },
  {
    id: 3,
    url: 'https://blog.naver.com/bongking52/224077949280',
    thumbnail: images.indoor,
    titleKr: '회식 장소로 강추합니다',
    titleEn: 'Highly Recommend for Team Dinners',
    excerptKr: '회사 회식으로 방문했는데 프라이빗한 공간에서 눈치 안보고 즐길 수 있어서 좋았어요.',
    excerptEn: 'Visited for company dinner - loved the private space where we could enjoy freely.'
  }
];

export const translations = {
  ko: {
    // Language Gate
    selectLanguage: '언어를 선택해주세요',
    korean: '한국어',
    english: 'English',
    subtitle: 'Private Rooftop Party Clubhouse in Gangnam',
    
    // Header
    reserve: '예약하기',
    inquiry: '문의하기',
    naverPlace: '네이버 리뷰 보기', 
    instagram: '인스타그램',
    call: '전화',
    
    // Hero
    heroTitle: '강남 프라이빗 루프탑\n파티룸',
    heroSubtitle: '불멍 · BBQ · 단독 대관',
    heroDesc: '코엑스 도보 5분\n프라이빗 파티 · 생일 · 모임 전용 공간',
    naverReserve: '네이버 스마트스토어 예약하기',
    kakaoInquiry: '문의하기',
    badge1: '실사용 고객 사진',
    badge2: '단독 대관 전용',
    badge3: '루프탑 불멍',
    
    // Social Proof
    naverRating: '네이버 평점 ★★★★★',
    realReviews: '실사용 후기 다수',
    returning: '재방문 고객 많음',
    viewNaverReviews: '네이버 후기 보기',
    viewBlogReviews: '블로그 후기 보기',
    
    // Experience
    experienceTitle: '여기서 이렇게 놀아요',
    exp1: '루프탑 불멍 & BBQ',
    exp2: '프라이빗 파티룸',
    exp3: '게이밍 라운지',
    
    // Rooftop Emotion
    rooftopTitle: '강남 한복판에서 즐기는 루프탑 불멍',
    rooftopDesc: '도심에서 보기 힘든 진짜 루프탑 공간\n야경, 불멍, BBQ까지 한 번에 즐기는 프라이빗 파티',
    
    // Party Room
    partyTitle: '프라이빗 파티룸 단독 대관',
    partyDesc: '생일파티, 브라이덜샤워, 친구 모임까지\n눈치 보지 않고 마음껏 즐기는 공간',
    
    // BBQ
    bbqTitle: '바비큐 파티 완벽 준비',
    bbq1: '그릴 완비 (유료)',
    bbq2: '식재료 반입 가능',
    bbq3: '야외 루프탑 BBQ',
    
    // Who Its For
    whoTitle: '이런 분들께 딱입니다',
    who1: '친구 모임',
    who2: '생일 파티',
    who3: '커플 데이트',
    who4: '회사 회식',
    who5: '동호회 모임',
    who6: '프라이빗 파티',
    
    // Blog Reviews
    blogTitle: '실제 방문 후기',
    blogSubtitle: '광고 아닌 진짜 블로그 후기입니다',
    viewFullReview: '후기 전체 보기',
    
    // Location
    locationTitle: '위치가 깡패입니다',
    location1: '강남 삼성동',
    location2: '코엑스 도보 5분',
    location3: '접근성 최고',
    viewNaverMap: '네이버 지도 보기',
    viewNaverPlace: '네이버 플레이스 바로가기',
    
    // Booking Funnel
    bookingTitle: '예약은 이렇게 합니다',
    step1: '네이버 스마트스토어 접속',
    step2: '날짜 / 시간 선택',
    step3: '결제',
    step4: '예약 확정 문자 수신',
    
    // Contact
    contactTitle: '빠른 문의',
    kakaoContact: '문의하기',
    phoneContact: '전화하기',
    instaDM: '인스타 DM',
    formName: '이름',
    formPhone: '연락처',
    formDate: '이용 날짜',
    formPeople: '인원',
    formMessage: '문의 내용',
    formSubmit: '문의 보내기',
    
    // Gallery
    galleryTitle: '실사용 고객 사진',
    galleryCaption: '100% 실제 이용 고객 사진입니다.',
    
    // FAQ
    faqTitle: '자주 묻는 질문',
    faq1Q: '최대 수용 인원은 몇 명인가요?',
    faq1A: '기본 4인 기준이며, 추가 인원은 1인당 15,000원입니다. 최대 20명까지 수용 가능합니다.',
    faq2Q: '주차는 가능한가요?',
    faq2A: '무료 주차 1대 가능하며, 도보 3분 거리에 공영 주차장이 있습니다.',
    faq3Q: '음식/음료 반입이 가능한가요?',
    faq3A: '네, 외부 음식 및 주류 반입이 가능합니다! BBQ 그릴 세트는 별도 요금이며 인원에 따라 40,000원부터 시작합니다.',
    faq4Q: '예약 취소/변경은 어떻게 하나요?',
    faq4A: '예약 취소 및 환불 규정은 예약하신 플랫폼(여기어때, 스페이스클라우드, 네이버 등)의 정책을 따릅니다.',
    faq5Q: '반려동물 동반이 가능한가요?',
    faq5A: '네, 반려동물 동반 가능합니다. (마리당 10,000원 추가 비용 발생)',
    faq6Q: '이용 가능 시간은 어떻게 되나요?',
    faq6A: '낮 패키지(11:00-18:00), 밤 패키지(19:00-익일 10:00), 올데이(11:00-익일 10:00) 중 선택 가능합니다.',
    faq7Q: '어떤 시설이 제공되나요?',
    faq7A: '85인치 TV, 고급 가죽 쇼파, 고사양 PC 4대(32인치 모니터), 레이싱카 오락기, 미니바, 와인 냉장고, 전자레인지, 다트 게임, PS5, 닌텐도 스위치, 보드게임, 11인승 포커테이블, BBQ 그릴, 루프탑(5층), 불멍(5층), 만화책, 내부 화장실, 샤워시설, 온수시스템, 케이블TV, 노래방기기, 커피머신, 휴대용 가스버너, 4층 테라스(흡연가능)',
    faq8Q: '화장실이 있나요?',
    faq8A: '네, 내부에 깨끗한 화장실과 샤워 시설이 있습니다.',
    faq9Q: '흡연이 가능한가요?',
    faq9A: '4층 테라스와 루프탑에서만 흡연 가능합니다. 실내는 절대 금연입니다.',
    faq10Q: '대중교통으로 어떻게 가나요?',
    faq10A: '삼성역 5번 출구에서 도보 5분, 코엑스 정문에서 도보 3분 거리입니다.',
    faq11Q: '케이터링 서비스가 있나요?',
    faq11A: '별도 케이터링은 없으나, 배달 및 외부 음식 반입이 자유롭습니다.',
    faq12Q: '생일파티 꾸미기가 가능한가요?',
    faq12A: '네! 풍선, 가랜드 등 데코레이션 자유롭게 가능합니다.',
    
    // Operating Hours
    hoursTitle: '이용 안내',
    hoursWeekday: '패키지 안내',
    hoursWeekend: '24시간 운영',
    hoursTime1: '낮 패키지: 11:00 - 18:00',
    hoursTime2: '밤 패키지: 19:00 - 10:00 (+1)',
    hoursTime3: '올데이: 11:00 - 10:00 (+1)',
    hoursNote: '* 예약제로 운영됩니다',
    
    // Footer
    businessInfo: 'Gangnam Playground COEX | Samseong-dong, Gangnam-gu, Seoul'
  },
  en: {
    // Language Gate
    selectLanguage: 'Please choose your language',
    korean: '한국어',
    english: 'English',
    subtitle: 'Private Rooftop Party Clubhouse in Gangnam',
    
    // Header
    reserve: 'Book Now',
    inquiry: 'Contact Us',
    naverPlace: 'View Naver Reviews',
    instagram: 'Instagram',
    call: 'Call',
    
    // Hero
    heroTitle: 'Gangnam Private Rooftop\nParty Room',
    heroSubtitle: 'Firepit · BBQ · Private Rental',
    heroDesc: '5 min walk from COEX\nPrivate Party · Birthday · Group Events',
    naverReserve: 'Book on Naver Smart Store',
    kakaoInquiry: 'Contact Us',
    badge1: 'Real Customer Photos',
    badge2: 'Exclusive Rental',
    badge3: 'Rooftop Firepit',
    
    // Social Proof
    naverRating: 'Naver Rating ★★★★★',
    realReviews: 'Many Real Reviews',
    returning: 'High Return Rate',
    viewNaverReviews: 'View Naver Reviews',
    viewBlogReviews: 'View Blog Reviews',
    
    // Experience
    experienceTitle: 'What You Can Do Here',
    exp1: 'Rooftop Firepit & BBQ',
    exp2: 'Private Party Room',
    exp3: 'Gaming Lounge',
    
    // Rooftop Emotion
    rooftopTitle: 'Rooftop Firepit in the Heart of Gangnam',
    rooftopDesc: 'A rare rooftop space in the city center\nEnjoy night views, firepit, and BBQ in one private party',
    
    // Party Room
    partyTitle: 'Private Party Room Exclusive Rental',
    partyDesc: 'From birthday parties to bridal showers and friend gatherings\nEnjoy freely without worry',
    
    // BBQ
    bbqTitle: 'Perfect BBQ Party Setup',
    bbq1: 'Grill Provided (Paid)',
    bbq2: 'Bring Your Own Food',
    bbq3: 'Outdoor Rooftop BBQ',
    
    // Who Its For
    whoTitle: 'Perfect For',
    who1: 'Friend Gatherings',
    who2: 'Birthday Parties',
    who3: 'Couple Dates',
    who4: 'Team Dinners',
    who5: 'Club Meetings',
    who6: 'Private Parties',
    
    // Blog Reviews
    blogTitle: 'Real Visit Reviews',
    blogSubtitle: 'Genuine blog reviews, not ads',
    viewFullReview: 'View Full Review',
    
    // Location
    locationTitle: 'Unbeatable Location',
    location1: 'Gangnam Samseong',
    location2: '5 min walk from COEX',
    location3: 'Best Accessibility',
    viewNaverMap: 'View Naver Map',
    viewNaverPlace: 'Go to Naver Place',
    
    // Booking Funnel
    bookingTitle: 'How to Book',
    step1: 'Visit Naver Smart Store',
    step2: 'Select Date / Time',
    step3: 'Payment',
    step4: 'Receive Confirmation Text',
    
    // Contact
    contactTitle: 'Quick Contact',
    kakaoContact: 'Contact Us',
    phoneContact: 'Call',
    instaDM: 'Instagram DM',
    formName: 'Name',
    formPhone: 'Phone',
    formDate: 'Date',
    formPeople: 'Group Size',
    formMessage: 'Message',
    formSubmit: 'Send Message',
    
    // Gallery
    galleryTitle: 'Real Customer Photos',
    galleryCaption: '100% real photos from actual customers.',
    
    // FAQ
    faqTitle: 'Frequently Asked Questions',
    faq1Q: 'What is the maximum capacity?',
    faq1A: 'Base capacity is 4 people, with ₩15,000 per additional person. Maximum capacity is 20 people.',
    faq2Q: 'Is parking available?',
    faq2A: 'One free parking space available, with public parking 3 minutes walk away.',
    faq3Q: 'Can I bring outside food/drinks?',
    faq3A: 'Yes! Outside food and alcohol are allowed. BBQ grill set is available for an additional fee starting from ₩40,000 depending on group size.',
    faq4Q: 'How do I cancel or change my reservation?',
    faq4A: 'Cancellation and refund policies follow the platform (Yanolja, Space Cloud, Naver, etc.) where you made your booking.',
    faq5Q: 'Are pets allowed?',
    faq5A: 'Yes, pets are allowed (₩10,000 additional fee per pet).',
    faq6Q: 'What are the available hours?',
    faq6A: 'Day package (11:00-18:00), Night package (19:00-10:00 next day), or All-day (11:00-10:00 next day).',
    faq7Q: 'What facilities are provided?',
    faq7A: '85" TV, premium leather sofa, 4 high-spec PCs (32" monitors), racing game machine, mini bar, wine fridge, microwave, dart game, PS5, Nintendo Switch, board games, 11-seat poker table, BBQ grill, rooftop (5F), firepit (5F), manga, bathroom, shower, hot water system, cable TV, karaoke machine, coffee machine, portable gas burner, 4F terrace (smoking allowed)',
    faq8Q: 'Is there a bathroom?',
    faq8A: 'Yes, there is a clean bathroom and shower facility inside.',
    faq9Q: 'Is smoking allowed?',
    faq9A: 'Smoking is only allowed on the 4F terrace and rooftop. Indoor smoking is strictly prohibited.',
    faq10Q: 'How do I get here by public transport?',
    faq10A: '5-minute walk from Samseong Station Exit 5, 3-minute walk from COEX main entrance.',
    faq11Q: 'Is catering service available?',
    faq11A: 'No separate catering, but delivery and outside food are freely allowed.',
    faq12Q: 'Can I decorate for a birthday party?',
    faq12A: 'Yes! Balloons, garlands, and other decorations are freely allowed.',
    
    // Operating Hours
    hoursTitle: 'Operating Information',
    hoursWeekday: 'Package Information',
    hoursWeekend: '24/7 Available',
    hoursTime1: 'Day Package: 11:00 - 18:00',
    hoursTime2: 'Night Package: 19:00 - 10:00 (+1)',
    hoursTime3: 'All-day: 11:00 - 10:00 (+1)',
    hoursNote: '* Reservation required',
    
    // Footer
    businessInfo: 'Gangnam Playground COEX | Samseong-dong, Gangnam-gu, Seoul'
  }
};
